const teamGrid = document.querySelector(".v_team__grid");
const html = document.querySelector("html");

if (teamGrid) {
  const yvesModal = document.querySelector("#v_team_modal__container_yves");
  const estelleModal = document.querySelector("#v_team_modal__container_estelle");
  const thomasModal = document.querySelector("#v_team_modal__container_thomas");

  const yvesPicture = document.querySelector("#v_yves_picture");
  const estellePicture = document.querySelector("#v_estelle_picture");
  const thomasPicture = document.querySelector("#v_thomas_picture");

  const closeButtons = document.querySelectorAll(".v_team_modal__close");

    handleModal(yvesModal, yvesPicture);
    handleModal(estelleModal, estellePicture);
    handleModal(thomasModal, thomasPicture);

  closeButtons.forEach((closeButton) => {
    closeButton.addEventListener("click", () => {
      yvesModal.style.display = "none";
      estelleModal.style.display = "none";
      thomasModal.style.display = "none";
      unblockOverflow()
    });
  });
}

function handleModal(modal, picture) {
  picture?.addEventListener("click", () => {
    modal.style.display = "block";
    blockOverflow()
  });

  modal?.addEventListener("click", (event) => {
    modal.style.display = "none";
    unblockOverflow()
  });
}

function blockOverflow() {
  html.style.overflow = "hidden";
}

function unblockOverflow() {
  html.style.overflowX = "hidden";
  html.style.overflowY = "auto";
}
